/* eslint-disable */
import Vue from 'vue';
import {
  ADD_SERVER_ERROR,
  ADD_SERVER_SUCCESS,
  START_GLOBAL_LOADER,
  STOP_GLOBAL_LOADER,
  COMPANY_FETCHED,
  UPDATE_COMPANY_FILTERS,
  UPDATE_LIST_FILTERS,
  UPDATE_VERSION,
  APP_UPDATED,
  UPDATE_FILTERS,
  UPDATE_PRESENCE,
} from './mutation-types';

export default {
  [COMPANY_FETCHED](state, payload) {
    // eslint-disable-next-line
    state.selectedCompany = Object.assign({}, payload);
  },
  [ADD_SERVER_ERROR](state, payload) {
    // eslint-disable-next-line
    state.errors = [];
    if (payload && payload.errors && !(payload.errors instanceof Array)) {
      Object.values(payload.errors).forEach((value) => {
        value.forEach((item) => {
          state.errors.push({
            title: payload.message,
            text: item,
          });
        });
        // state.errors.push({
        //   title: payload.message,
        //   text: value[0],
        // });
      });
    } else if (payload && payload.errors && payload.errors instanceof Array) {
      payload.errors.forEach((val) => {
        state.errors.push({
          title: payload.message,
          text: val,
        });
      });
    } else if (payload && payload.message) {
      state.errors.push({
        title: payload.message,
      });
    } else {
      state.errors.push({
        title: 'Something went wrong, please contact administrator.',
      });
    }
  },
  [ADD_SERVER_SUCCESS](state, payload) {
    if (payload.message) {
      state.successes.push({
        title: payload.message,
      });
    }

    if (state.successes.length > state.maxSuccesses) {
      state.successes.shift();
    }
  },
  [START_GLOBAL_LOADER](state) {
    state.globalLoading = true;
  },
  [STOP_GLOBAL_LOADER](state) {
    state.globalLoading = false;
  },
  [UPDATE_COMPANY_FILTERS](state, payload) {
    state.companyFilters = payload ? Object.assign({}, payload) : null;
  },
  [UPDATE_LIST_FILTERS](state, payload) {
    state[`${payload.entity}Filters`] = payload.filters ? Object.assign({}, payload.filters) : null;
  },
  [UPDATE_VERSION](state, payload) {
    if (state.version !== payload.version && state.version !== null) {
      state.appUpdated = true;
    }
    state.version = payload.version;
    state.build = payload.build;
  },
  [APP_UPDATED](state) {
    state.appUpdated = false;
  },
  [UPDATE_FILTERS](state, payload) {
    state.filters[payload.name] = payload.params;
  },
  [UPDATE_PRESENCE](state, payload) {
    // Vue.set(state.presence, payload.channel, payload.flag)
    // state.presence[payload.channel] = payload.flag;
    const obj = {};
    obj[payload.channel] = payload.flag;
    state.presence = Object.assign({}, state.presence, obj);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/common/mutations.js